/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespEditorialModuleItem_item = {
    readonly description: string | null;
    readonly cta: string | null;
    readonly imageUrl: string | null;
    readonly imageWidth: string | null;
    readonly imageHeight: string | null;
    readonly linkData: {
        readonly " $fragmentRefs": FragmentRefs<"HpRespModuleItemTile_linkData">;
    };
    readonly " $refType": "HpRespEditorialModuleItem_item";
};
export type HpRespEditorialModuleItem_item$data = HpRespEditorialModuleItem_item;
export type HpRespEditorialModuleItem_item$key = {
    readonly " $data"?: HpRespEditorialModuleItem_item$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespEditorialModuleItem_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespEditorialModuleItem_item",
  "type": "EditorialItem",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "cta",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageWidth",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageHeight",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "linkData",
      "storageKey": null,
      "args": null,
      "concreteType": "LinkData",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "HpRespModuleItemTile_linkData",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '71e55e56906ee186d6f7b6b66801a2be';
export default node;
